import { CheckboxFilter } from '@lifebit-ai/lds'
import React from 'react'

import type { Option } from 'modules/types'
import { useGetUsersFromDataAccessRequests } from 'services/data-access-requests/hooks/useGetUsersFromDataAccessRequests'

interface DataAccessRequestRequestedByFilterProps {
  onApply: (filteredOptions: Option[]) => void
  onReset: () => void
}

export const DataAccessRequestRequestedByFilter = ({ onApply, onReset }: DataAccessRequestRequestedByFilterProps) => {
  const requestersQuery = useGetUsersFromDataAccessRequests()

  const options =
    requestersQuery.data?.data.map(item => ({
      label: item.email,
      value: item._id
    })) ?? []

  return (
    <CheckboxFilter
      label="Requested by"
      loading={requestersQuery.isLoading}
      onApply={onApply}
      options={options}
      onReset={onReset}
      searchFieldPlaceholder="Search by email"
    />
  )
}
